// extracted by mini-css-extract-plugin
export var actions = "_sh-4";
export var item = "_sh-1";
export var price = "_sh-3";
export var quantity = "_sh-2";
export var table = "_sh-0";